export default __webpack_public_path__ + "static/property-description-graph-t-763ad0b01cf9686980d5d5c660c59d65.jpg";